import { type Messages } from './fr';

// Traduction arabe (arabe standard moderne) du portail. Mêmes clés que `fr`, imposées par le type `Messages`.
// Textes visibles : pas de tiret cadratin, pas de nom de fournisseur d'infrastructure.

export const ar: Messages = {
  appName: 'Beta Assur',
  tagline: 'إدارة آجال الأقساط والتذكير بها',
  common: {
    loading: 'جارٍ التحميل…',
    retry: 'إعادة المحاولة',
    save: 'حفظ',
    saved: 'تم الحفظ',
    cancel: 'إلغاء',
    confirm: 'تأكيد',
    create: 'إنشاء',
    edit: 'تعديل',
    delete: 'حذف',
    close: 'إغلاق',
    search: 'بحث',
    filter: 'تصفية',
    reset: 'إعادة الضبط',
    all: 'الكل',
    none: 'لا شيء',
    yes: 'نعم',
    no: 'لا',
    loadMore: 'عرض المزيد',
    empty: 'لا توجد عناصر لعرضها.',
    actions: 'الإجراءات',
    back: 'رجوع',
    details: 'التفاصيل',
    required: 'حقل إلزامي',
    forbidden: 'ليست لديك الصلاحيات اللازمة للوصول إلى هذه الصفحة.',
    notFound: 'الصفحة غير موجودة.',
    errorTitle: 'حدث خطأ',
    requestId: 'مرجع الطلب',
    from: 'من',
    to: 'إلى',
    language: 'اللغة',
    sovereign: 'البيانات مستضافة على بنية تحتية سيادية.',
  },
  nav: {
    label: 'التنقل الرئيسي',
    dashboard: 'لوحة القيادة',
    installments: 'الأقساط',
    portfolio: 'العقود والمؤمَّن لهم',
    scenarios: 'السيناريوهات والنماذج',
    worklist: 'قائمة المهام',
    imports: 'الاستيراد والتصدير',
    reports: 'التقارير',
    cash: 'الصندوق',
    settings: 'الإعدادات',
    logout: 'تسجيل الخروج',
    skipToContent: 'الانتقال إلى المحتوى',
    openMenu: 'فتح القائمة',
    collapse: 'تصغير القائمة',
    expand: 'توسيع القائمة',
  },
  theme: {
    label: 'المظهر',
    light: 'فاتح',
    dark: 'داكن',
    system: 'حسب النظام',
  },
  account: {
    title: 'حسابي',
    display: 'العرض',
    compactMenu: 'قائمة جانبية مصغرة (أيقونات فقط)',
    savedOnAccount: 'تُحفظ تفضيلاتكم في حسابكم وترافقكم على كل أجهزتكم.',
    profile: 'الملف الشخصي',
    name: 'الاسم المعروض',
    role: 'الدور',
    tenant: 'المكتب',
    password: 'كلمة المرور',
    currentPassword: 'كلمة المرور الحالية',
    newPassword: 'كلمة المرور الجديدة',
    confirmPassword: 'تأكيد كلمة المرور الجديدة',
    passwordHint: '12 حرفا على الأقل؛ العبارة أكثر أمانا.',
    changePassword: 'تغيير كلمة المرور',
    passwordChanged: 'تم تغيير كلمة المرور. تم إغلاق جلساتكم الأخرى.',
    mismatch: 'كلمتا المرور الجديدتان غير متطابقتين.',
  },
  roles: {
    admin: 'مدير النظام',
    manager: 'مسيّر',
    agent: 'وكيل',
    readonly: 'قراءة فقط',
  },
  auth: {
    sso: {
      or: 'أو',
      button: 'الدخول عبر Beta Suite',
      tenantRequired: 'أدخلوا أولا رمز المكتب.',
      echec: 'فشل الدخول عبر Beta Suite. أعيدوا المحاولة أو استعملوا كلمة المرور.',
      mfa: 'يتطلب حسابكم مصادقة قوية: فعّلوها على Beta Suite أو ادخلوا بكلمة المرور والرمز.',
      indisponible: 'الدخول عبر Beta Suite غير مفعل لهذا المكتب.',
    },
    loginTitle: 'تسجيل الدخول',
    tenantCode: 'رمز المكتب',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    totp: 'رمز التحقق (6 أرقام)',
    totpHint: 'أدخل الرمز الظاهر في تطبيق المصادقة الخاص بك.',
    submit: 'دخول',
    invalid: 'بيانات الدخول غير صحيحة.',
    locked: 'محاولات كثيرة جدًا. أعد المحاولة بعد بضع دقائق.',
    invitationTitle: 'تفعيل حسابك',
    invitationIntro: 'اختر كلمة المرور للوصول إلى البوابة.',
    passwordConfirm: 'تأكيد كلمة المرور',
    passwordMismatch: 'كلمتا المرور غير متطابقتين.',
    passwordPolicy: '12 حرفًا على الأقل. يُنصح باستعمال عبارة مرور.',
    activate: 'تفعيل الحساب',
    activated: 'تم تفعيل الحساب. يمكنك الآن تسجيل الدخول.',
    goToLogin: 'الذهاب إلى تسجيل الدخول',
    missingToken: 'رابط الدعوة غير مكتمل.',
  },
  status: {
    upcoming: 'قادم',
    due: 'مستحق',
    overdue: 'متأخر',
    partial: 'جزئي',
    paid: 'مدفوع',
    waived: 'متنازل عنه',
    cancelled: 'ملغى',
  },
  contractStatus: {
    active: 'ساري',
    suspended: 'معلَّق',
    lapsed: 'ساقط',
    cancelled: 'مفسوخ',
    expired: 'منتهي الصلاحية',
  },
  sequenceStatus: {
    scheduled: 'مبرمج',
    running: 'جارٍ',
    paused: 'متوقف مؤقتًا',
    stopped_paid: 'موقوف (تم الدفع)',
    stopped_optout: 'موقوف (اعتراض)',
    stopped_manual: 'موقوف',
    escalated: 'محال للمعالجة',
    completed: 'مكتمل',
  },
  channels: { whatsapp: 'WhatsApp', sms: 'SMS', email: 'البريد الإلكتروني' },
  paymentMethods: {
    kashy: 'الدفع عبر الإنترنت',
    agency: 'في الوكالة',
    bank: 'تحويل بنكي',
    check: 'صك',
    other: 'أخرى',
  },
  languages: { fr: 'الفرنسية', ar: 'العربية' },
  periodicity: {
    annual: 'سنوية',
    semiannual: 'نصف سنوية',
    quarterly: 'فصلية',
    monthly: 'شهرية',
    single: 'دفعة واحدة',
  },
  families: {
    auto: 'السيارات',
    health: 'الصحة',
    life: 'الحياة والادخار',
    home: 'المسكن',
    business: 'المؤسسات',
    other: 'أخرى',
  },
  dashboard: {
    alertLabels: {
      draft_mode: 'وضع المسودة مفعل: لا تُرسل أي رسالة إلى المؤمَّن لهم.',
      missing_phone: {
        one: 'مؤمَّن له واحد دون رقم يمكن الاتصال به.',
        two: 'مؤمَّن لهما دون رقم يمكن الاتصال به.',
        few: '{n} مؤمَّن لهم دون رقم يمكن الاتصال به.',
        other: '{n} مؤمَّن له دون رقم يمكن الاتصال به.',
      },
      failed_messages: {
        one: 'رسالة واحدة لم تصل خلال 7 أيام.',
        two: 'رسالتان لم تصلا خلال 7 أيام.',
        few: '{n} رسائل لم تصل خلال 7 أيام.',
        other: '{n} رسالة لم تصل خلال 7 أيام.',
      },
      import_failed: {
        one: 'استيراد واحد فاشل خلال 7 أيام.',
        two: 'استيرادان فاشلان خلال 7 أيام.',
        few: '{n} عمليات استيراد فاشلة خلال 7 أيام.',
        other: '{n} عملية استيراد فاشلة خلال 7 أيام.',
      },
      sending_suspended: 'الإرسال موقوف بعد كثرة الإخفاقات: تحققوا ثم أعيدوا التفعيل في الإعدادات.',
      templates_rejected: {
        one: 'نموذج واحد رُفض في موافقة واتساب.',
        two: 'نموذجان رُفضا في موافقة واتساب.',
        few: '{n} نماذج رُفضت في موافقة واتساب.',
        other: '{n} نموذجا رُفض في موافقة واتساب.',
      },
      orphan_payments: {
        one: 'دفعة واحدة يجب تخصيصها.',
        two: 'دفعتان يجب تخصيصهما.',
        few: '{n} دفعات يجب تخصيصها.',
        other: '{n} دفعة يجب تخصيصها.',
      },
    },
    title: 'لوحة القيادة',
    dueNext30: 'المتبقي للتحصيل (30 يومًا)',
    recovered30: 'المحصَّل (30 يومًا)',
    paidBeforeDueRate: 'المدفوعة في الأجل (90 يومًا)',
    overdueOver15: 'المتخلدات لأكثر من 15 يومًا',
    activeSequences: 'سلاسل التذكير النشطة',
    messagesThisMonth: 'رسائل الشهر',
    messagesCost: 'التكلفة',
    dueToday: 'أقساط اليوم',
    openEscalations: 'الإحالات المفتوحة',
    lastPayments: 'آخر الدفعات',
    alerts: 'التنبيهات',
    noAlert: 'لا توجد تنبيهات.',
    draftBanner: 'وضع المسودة: التذكيرات محاكاة فقط ولا تُرسل أي رسالة.',
    chart: 'المستحق والمحصَّل أسبوعيًا (12 أسبوعًا)',
    due: 'المستحق',
    recovered: 'المحصَّل',
    weekOf: 'أسبوع',
  },
  installments: {
    title: 'الأقساط',
    policy: 'وثيقة التأمين',
    policyholder: 'المؤمَّن له',
    product: 'المنتج',
    dueDate: 'تاريخ الاستحقاق',
    amountDue: 'المبلغ المستحق',
    amountPaid: 'المدفوع',
    status: 'الحالة',
    sequence: 'التذكير',
    nextRun: 'الإرسال القادم',
    agent: 'الوكيل',
    step: 'المرحلة',
    minAmount: 'الحد الأدنى للمبلغ (د.ت)',
    maxAmount: 'الحد الأقصى للمبلغ (د.ت)',
    channel: 'القناة المفضلة',
    sequenceStatus: 'حالة التذكير',
    noPhone: 'دون رقم يمكن الاتصال به',
    highRisk: 'خطر عدم الدفع مرتفع',
    risk: 'الخطر',
    riskFactors: {
      late_history: 'يدفع غالبا متأخرا',
      very_late_history: 'تأخيرات طويلة',
      currently_overdue: 'متأخر',
      no_history: 'دون سجل',
      unreachable: 'لا يمكن الاتصال به',
      opted_out: 'رافض للرسائل',
      delivery_failures: 'رسائل لم تصل',
    },
    insurer: 'شركة التأمين',
    detailTitle: 'القسط',
    period: 'الفترة المشمولة',
    graceUntil: 'نهاية مهلة السماح',
    suspensionAt: 'التعليق المتوقع',
    source: 'المصدر',
    sources: { computed: 'محتسب', imported: 'مستورد', api: 'API' },
    timeline: 'التسلسل الزمني',
    noTimeline: 'لا توجد أحداث لهذا القسط.',
    timelineKinds: {
      sequence: 'تذكير',
      message: 'رسالة',
      payment: 'دفع',
      audit: 'إجراء',
    },
    openContract: 'عرض العقد',
    openPolicyholder: 'عرض المؤمَّن له',
  },
  cash: {
    title: 'دفتر الصندوق',
    date: 'يوم التسجيل',
    mine: 'المبالغ التي سجلتموها في هذا اليوم.',
    team: 'المبالغ التي سجلها كامل الفريق في هذا اليوم.',
    totals: 'المجاميع حسب طريقة الدفع',
    total: 'مجموع المقبوضات',
    payments: {
      zero: 'لا دفعة',
      one: 'دفعة واحدة',
      two: 'دفعتان',
      few: '{n} دفعات',
      many: '{n} دفعة',
      other: '{n} دفعة',
    },
    none: 'لا توجد مقبوضات مسجلة في هذا اليوم.',
    time: 'الساعة',
    method: 'الطريقة',
    reference: 'المرجع',
    amount: 'المبلغ',
    print: 'طباعة',
  },
  mandate: {
    title: 'الاقتطاع الآلي',
    none: 'لا يوجد اقتطاع: يمكن للمؤمَّن له تفعيله من صفحته.',
    cap: 'سقف كل اقتطاع',
    since: 'مفعل منذ',
    cancel: 'إيقاف الاقتطاع',
    cancelMessage: 'لن تُقتطع الأقساط التالية؛ تُستأنف التذكيرات.',
    installment: 'القسط',
    statuses: { pending: 'في انتظار الإمضاء', active: 'مفعل', cancelled: 'موقوف', failed: 'مرفوض' },
    chargeStatuses: { pending: 'جار', succeeded: 'تم الاقتطاع', failed: 'مرفوض' },
  },
  claims: {
    title: 'الحوادث المصرح بها',
    none: 'لا يوجد حادث مصرح به.',
    declare: 'تسجيل تصريح',
    kind: 'نوع الحادث',
    kinds: {
      accident: 'حادث',
      theft: 'سرقة',
      fire: 'حريق',
      water_damage: 'أضرار المياه',
      glass_breakage: 'كسر الزجاج',
      other: 'أخرى',
    },
    occurredOn: 'تاريخ الحادث',
    place: 'المكان',
    description: 'الظروف',
    noHealth: 'لا معلومات صحية: الظروف المادية فقط.',
    thirdParty: 'يوجد طرف ثالث',
    withThirdParty: 'مع طرف ثالث',
    save: 'تسجيل',
    status: 'المتابعة',
    statuses: { received: 'مستلم', forwarded: 'محال إلى شركة التأمين', closed: 'مغلق' },
  },
  renewal: {
    title: 'التجديد',
    none: 'لا يوجد مقترح تجديد.',
    premium: 'القسط السنوي المقترح (د.ت)',
    validUntil: 'الرد مطلوب قبل',
    validUntilHint: 'افتراضيا، تاريخ انتهاء العقد.',
    propose: 'اقتراح التجديد',
    invalid: 'قسط غير صالح: المبلغ بالدينار (مثال 480,000).',
    cancel: 'سحب',
    cancelMessage: 'لن يتمكن المؤمَّن له من الرد على هذا المقترح.',
    statuses: {
      pending: 'في الانتظار',
      accepted: 'مقبول',
      declined: 'مرفوض',
      cancelled: 'مسحوب',
    },
  },
  coverage: {
    title: 'الضمانات',
    attestation: 'شهادة خلاص القسط (PDF)',
    none: 'لا توجد ضمانات مفصلة لهذا العقد.',
    code: 'الرمز',
    label: 'التسمية',
    sumInsured: 'رأس المال المؤمن (د.ت)',
    premiumPart: 'حصة القسط (د.ت)',
    add: 'إضافة ضمان',
    invalid: 'إدخال غير صالح: الرمز والتسمية والمبالغ بالدينار (مثال 1250,500).',
    noHealthData: 'لا تُدخل أي بيانات صحية: اسم الضمان ومبالغه فقط.',
  },
  endorsements: {
    title: 'الملاحق',
    none: 'لا توجد ملاحق.',
    currentPremium: 'القسط السنوي الساري',
    kind: 'النوع',
    kinds: {
      premium_change: 'تغيير القسط',
      coverage_change: 'تغيير الضمانات',
      object_change: 'تغيير الشيء المؤمن',
      address_change: 'تغيير العنوان',
      other: 'أخرى',
    },
    effectiveDate: 'تاريخ السريان',
    delta: 'تغيّر القسط السنوي (د.ت)',
    deltaHint: 'سالب في حالة التخفيض (مثال -50). يُعاد احتساب الأقساط المستقبلية.',
    note: 'تعليق',
    add: 'تسجيل الملحق',
    saved: 'تم تسجيل الملحق وإعادة احتساب جدول الأقساط.',
  },
  portfolio: {
    saveNotices: 'حفظ آجال الإشعار',
    notices: 'آجال الإشعار',
    inheritNotice: 'إعداد فرع التأمين',
    title: 'العقود والمؤمَّن لهم',
    contracts: 'العقود',
    policyholders: 'المؤمَّن لهم',
    searchContracts: 'رقم وثيقة التأمين',
    searchPolicyholders: 'الاسم أو الهاتف أو بطاقة التعريف أو البريد الإلكتروني',
    searchHint: 'حرفان على الأقل. الهاتف وبطاقة التعريف والبريد الإلكتروني: القيمة الدقيقة.',
    policyNumber: 'وثيقة التأمين',
    status: 'الحالة',
    effectiveDate: 'تاريخ السريان',
    expiryDate: 'تاريخ الانتهاء',
    periodicity: 'الدورية',
    premium: 'القسط السنوي',
    insuredObject: 'الشيء المؤمَّن عليه',
    insurer: 'شركة التأمين',
    product: 'المنتج',
    agent: 'الوكيل',
    noAgent: 'دون وكيل',
    schedule: 'جدول الأقساط',
    statusHistory: 'سجل الحالات',
    changeStatus: 'تغيير الحالة',
    newStatus: 'الحالة الجديدة',
    reason: 'السبب',
    statusChanged: 'تم تغيير الحالة.',
    newContract: 'عقد جديد',
    newPolicyholder: 'مؤمَّن له جديد',
    kind: 'النوع',
    person: 'شخص طبيعي',
    company: 'مؤسسة',
    firstName: 'الاسم',
    lastName: 'اللقب',
    companyName: 'الاسم الاجتماعي',
    externalRef: 'المرجع في نظام المعلومات',
    phone: 'الهاتف',
    phoneVerified: 'تم التحقق منه',
    email: 'البريد الإلكتروني',
    cin: 'بطاقة التعريف الوطنية',
    preferredChannel: 'القناة المفضلة',
    language: 'لغة الرسائل',
    optOut: 'الاعتراض على الرسائل',
    optOutSince: 'منذ',
    noOptOut: 'لا يوجد اعتراض',
    contact: 'الاتصال والتفضيلات',
    contractsOf: 'عقود المؤمَّن له',
    messages: 'سجل الرسائل',
    noMessages: 'لا توجد رسائل.',
    sequenceNo: 'رقم',
  },
  scenarios: {
    offsetFrom: 'محتسب من',
    fromDue: 'تاريخ الاستحقاق',
    fromNotice: 'تاريخ الإشعار',
    preferredFirst: 'القناة المفضلة للمؤمَّن له أولا',
    title: 'السيناريوهات والنماذج',
    applyToRunning:
      'التطبيق أيضًا على السلاسل الجارية (تُستأنف من المرحلة المقابلة في النسخة الجديدة)',
    simulation: 'محاكاة على المحفظة',
    simulate: 'محاكاة',
    simInstallments: 'الأقساط المعنية',
    simMessages: 'الرسائل المتوقعة',
    simEscalations: 'الإحالات المتوقعة',
    simNotStarted: 'أقساط دون سلسلة تذكير',
    simCost: 'التكلفة التقديرية',
    simCalendar: 'الرسائل المتوقعة حسب اليوم',
    scenarios: 'السيناريوهات',
    templates: 'النماذج',
    installLibrary: 'تثبيت المكتبة الافتراضية',
    libraryInstalled: 'تم تثبيت المكتبة',
    newScenario: 'سيناريو جديد',
    name: 'الاسم',
    family: 'عائلة المنتجات',
    anyFamily: 'كل العائلات',
    isDefault: 'افتراضي',
    status: 'الحالة',
    statuses: { draft: 'مسودة', published: 'منشور', archived: 'مؤرشف' },
    version: 'النسخة',
    published: 'النسخة المنشورة',
    hasDraft: 'مسودة قيد الإعداد',
    steps: 'المراحل',
    addMessage: 'إضافة رسالة',
    addEscalation: 'إضافة إحالة',
    offset: 'اليوم (بالنسبة إلى تاريخ الاستحقاق)',
    kind: 'النوع',
    kinds: { message: 'رسالة', escalation: 'إحالة' },
    channel: 'القناة',
    template: 'النموذج',
    fallback: 'بديل',
    noFallback: 'دون بديل',
    fallbackTemplate: 'النموذج البديل',
    label: 'التسمية',
    condition: 'الشرط',
    noCondition: 'دائمًا',
    conditionStatus: 'فقط إذا كان القسط',
    moveUp: 'نقل للأعلى',
    moveDown: 'نقل للأسفل',
    removeStep: 'حذف المرحلة',
    stopOnPayment: 'الإيقاف عند الدفع',
    pauseOnPromise: 'توقف مؤقت عند الوعد بالدفع (أيام)',
    publish: 'نشر',
    publishConfirm: 'نشر هذه النسخة؟ تحتفظ السلاسل الجارية بنسختها.',
    duplicate: 'نسخ',
    archive: 'أرشفة',
    archiveConfirm: 'أرشفة هذا السيناريو؟',
    preview: 'معاينة التسلسل الزمني',
    previewDueDate: 'لقسط مستحق في',
    plannedAt: 'الإرسال المتوقع',
    day: 'ي',
    newTemplate: 'نموذج جديد',
    body: 'نص الرسالة',
    variables: 'المتغيرات المتاحة',
    renderPreview: 'معاينة ببيانات وهمية',
    missingVariables: 'متغيرات دون قيمة',
    templateStatuses: {
      draft: 'مسودة',
      pending: 'قيد المصادقة',
      approved: 'مصادق عليه',
      rejected: 'مرفوض',
    },
    templateName: 'الاسم التقني (a-z، 0-9، _)',
    readOnlyTemplate: 'نموذج مصادق عليه أو قيد المصادقة: للقراءة فقط.',
  },
  imports: {
    title: 'الاستيراد والتصدير',
    history: 'سجل عمليات الاستيراد',
    newImport: 'استيراد جديد',
    kind: 'نوع الملف',
    kinds: {
      contracts: 'العقود والمؤمَّن لهم',
      installments: 'جداول الأقساط',
      payments: 'الدفعات',
    },
    file: 'ملف CSV أو XLSX (5 ميغابايت كحد أقصى)',
    upload: 'رفع',
    mapping: 'مطابقة الأعمدة',
    field: 'حقل Beta Assur',
    column: 'عمود الملف',
    ignore: 'تجاهل',
    saveMapping: 'الحفظ لعمليات الاستيراد القادمة',
    validate: 'التحقق من أول 20 سطرًا',
    missing: 'حقول إلزامية دون عمود',
    line: 'السطر',
    errors: 'الأخطاء',
    warnings: 'التحذيرات',
    ok: 'صالح',
    dryRun: 'تشغيل المحاكاة',
    dryRunRequired: 'المحاكاة إلزامية قبل أول استيراد فعلي.',
    run: 'تشغيل الاستيراد الفعلي',
    runConfirm: 'تشغيل الاستيراد الفعلي؟ سيتم تسجيل بيانات الملف.',
    markAbsent: 'فسخ العقود السارية غير الموجودة في الملف',
    progress: 'التقدم',
    report: 'تنزيل تقرير الأخطاء',
    statuses: {
      uploaded: 'تم الرفع',
      mapping: 'المطابقة',
      validating: 'التحقق',
      processing: 'قيد المعالجة',
      completed: 'مكتمل',
      failed: 'فشل',
    },
    simulation: 'محاكاة',
    real: 'فعلي',
    rows: 'الأسطر',
    rowsOk: 'صالحة',
    rowsError: 'بها أخطاء',
    rowsWarning: 'بها تحذيرات',
    summary: 'النتيجة',
    createdAt: 'أُنشئ في',
    exportsSoon: 'عمليات التصدير المصفّاة متاحة من كل شاشة قائمة.',
  },
  notice: {
    presets: { 30: 'شهر (30 يوما)', 60: 'شهران (60 يوما)', 90: 'ثلاثة أشهر (90 يوما)' },
    custom: 'مخصص',
    days: 'أيام',
  },
  subscription: {
    tab: 'الاشتراك',
    noPlan: 'دون عرض',
    legacy: 'مكتب قديم: دون حدود ودون حذف أي وظيفة. اتصلوا بـ Beta Suite لاختيار عرض.',
    statuses: {
      trial: 'تجربة مجانية',
      active: 'نشط',
      past_due: 'دفع متأخر',
      suspended: 'معلَّق',
      cancelled: 'ملغى',
    },
    trialEnds: (date: string) =>
      `تجربة مجانية إلى غاية ${date} في وضع المسودة. اختاروا عرضا للمواصلة بعدها.`,
    trialConfirmed: (plan: string, date: string) =>
      `تم اختيار عرض ${plan}: يبدأ الاشتراك يوم ${date} عند نهاية التجربة.`,
    suspended: 'الاشتراك معلَّق: توقف الإرسال الفعلي وتبقى بياناتكم متاحة. اختاروا عرضا للاستئناف.',
    cancelled: 'الاشتراك ملغى: اتصلوا بـ Beta Suite لاستئنافه.',
    cancelScheduled: (date: string) => `الإلغاء مبرمج يوم ${date}.`,
    renewsOn: (date: string) => `التجديد القادم يوم ${date}.`,
    cycleLabel: 'الفوترة',
    cycles: { monthly: 'شهرية', annual: 'سنوية' },
    nextCycle: (cycle: string) => `${cycle} ابتداء من التجديد القادم`,
    messagesThisMonth: 'الرسائل المرسلة هذا الشهر (المشمولة)',
    limitNames: {
      users: 'المستخدمون',
      activeContracts: 'العقود السارية',
      insurers: 'شركات التأمين',
    },
    unlimited: 'غير محدود',
    overageHint: 'بعد الرسائل المشمولة، تُفوتر كل رسالة حسب تعريفة العرض.',
    plans: 'العروض',
    pricesHint: 'الأسعار دون احتساب الأداءات؛ العرض السنوي يعادل عشرة أشهر.',
    perMonth: 'دون أداءات / شهريا',
    perYear: 'دون أداءات / سنويا',
    includedMessages: (n: number) => `${n.toLocaleString('fr-FR')} رسالة مشمولة شهريا`,
    features: {
      public_api: 'واجهة برمجية لنظامكم',
      webhooks: 'إشعارات آلية صادرة',
      direct_debit: 'الاقتطاع الآلي',
      sso: 'الحساب الموحد Beta Suite',
      sftp: 'ربط نظام المعلومات (SFTP وموصل)',
      llm_assist: 'قراءة مساعدة للردود',
    },
    included: 'مشمول',
    notIncluded: 'غير مشمول',
    current: 'العرض الحالي',
    choose: 'اختيار هذا العرض',
    keep: 'تغيير دورة الفوترة',
    confirmTitle: (plan: string) => `الانتقال إلى عرض ${plan}`,
    adjustmentDue: 'تسوية تضاف إلى الكشف القادم:',
    adjustmentCredit: 'رصيد يُطرح من الكشف القادم:',
    effectiveOn: 'يسري ابتداء من',
    blocked: 'استعمالكم يتجاوز حدود هذا العرض:',
    cancel: 'إلغاء الاشتراك',
    cancelMessage: 'ينتهي الاشتراك عند نهاية الفترة الجارية. يمكنكم التراجع عن الإلغاء قبل ذلك.',
    revertCancel: 'التراجع عن الإلغاء',
    history: 'السجل',
    events: {
      created: 'إنشاء الاشتراك',
      confirmed: 'اختيار العرض',
      started: 'بداية الاشتراك',
      renewed: 'تجديد',
      plan_changed: 'تغيير العرض',
      cycle_changed: 'تغيير دورة الفوترة',
      trial_expired: 'نهاية التجربة',
      cancel_requested: 'طلب إلغاء',
      cancel_reverted: 'التراجع عن الإلغاء',
      cancelled: 'إلغاء الاشتراك',
      status_changed: 'تعديل من Beta Suite',
    },
  },
  signup: {
    cta: 'لستم حرفاء بعد؟ أنشئوا فضاء وكالتكم',
    title: 'إنشاء فضاء وكالتكم',
    intro:
      'تجربة مجانية لمدة 30 يوما دون التزام. تدرس Beta Suite طلبكم ثم ترسل إليكم الدعوة عبر البريد الإلكتروني.',
    agencyName: 'اسم الوكالة',
    agentCode: 'رمز الوكيل العام',
    optional: 'اختياري',
    taxId: 'المعرف الجبائي',
    taxIdHint: 'مثال: 1234567A/M/000',
    city: 'المدينة',
    insurers: 'شركات التأمين الممثلة',
    insurersHint: 'مفصولة بفواصل',
    plan: 'العرض المطلوب',
    plans: {
      ESSENTIEL: 'Essentiel: وكيل مستقل',
      PRO: 'Pro: وكالة منظمة',
      RESEAU: 'Réseau: مكتب كبير',
    },
    adminName: 'اسمكم (المشرف)',
    phone: 'الهاتف',
    terms: 'أوافق على الشروط العامة للاستعمال وعلى معالجة هذه المعطيات لفتح فضائي.',
    submit: 'إرسال الطلب',
    haveAccount: 'لدي حساب',
    received: 'شكرا، تم تسجيل طلبكم. ستصلكم الدعوة عبر البريد الإلكتروني بمجرد قبوله.',
  },
  billing: {
    title: 'الفواتير والدفع',
    method: 'طريقة الدفع',
    transfer: 'تحويل بنكي',
    directDebit: 'اقتطاع آلي',
    mandatePending: 'التفويض في انتظار التوقيع',
    transferHint:
      'تُدفع كل فاتورة بتحويل بنكي في أجل 10 أيام مع ذكر رقمها. الاقتطاع الآلي يجنبكم النسيان.',
    startDirectDebit: 'تفعيل الاقتطاع الآلي',
    stopDirectDebit: 'إيقاف الاقتطاع الآلي',
    noInvoice: 'لا توجد فواتير حاليا.',
    number: 'الفاتورة',
    period: 'الشهر',
    total: 'المجموع بالأداءات',
    dueOn: 'تاريخ الاستحقاق',
    status: 'الحالة',
    statuses: { open: 'للدفع', paid: 'مدفوعة', void: 'ملغاة' },
    overdue: 'متأخرة',
    download: 'تحميل',
    simulationTitle: 'توقيع تفويض الاقتطاع (محاكاة)',
    simulationIntro: 'بيئة تجريبية: لا يُقتطع أي حساب. اختاروا نتيجة التوقيع.',
    sign: 'توقيع التفويض',
    refuse: 'رفض',
    banner: {
      past_due: 'فاتورة اشتراك حل أجلها.',
      suspended: 'حساب للقراءة فقط: الاشتراك معلَّق وتوقف الإرسال إلى المؤمَّن لهم.',
      cancelled: 'الاشتراك ملغى: حساب للقراءة فقط.',
    },
    bannerAction: 'التسوية',
    bannerContact: 'اتصلوا بمشرف مكتبكم.',
  },
  calls: {
    tab: 'مكالمات اليوم',
    title: 'الاتصال بالمؤمَّن له',
    noPhone: 'لا يوجد رقم يمكن الاتصال به: تثبتوا من معطيات المؤمَّن له.',
    remindersSent: (n: number) => `عدد رسائل التذكير المرسلة لهذا القسط: ${n}.`,
    payments: (list: string) => `الدفعات المسجلة: ${list}.`,
    noPayment: 'لا توجد دفعات مسجلة لهذا القسط.',
    callBackAt: 'إعادة الاتصال مبرمجة يوم',
    outcome: 'نتيجة المكالمة',
    outcomes: {
      reached: 'تم الاتصال',
      promise: 'وعد بالدفع',
      refused: 'رفض الدفع',
      no_answer: 'لا رد',
      wrong_number: 'رقم خاطئ',
      already_paid: 'يقول إنه دفع',
    },
    promiseDate: 'الدفع الموعود يوم',
    callBack: 'إعادة الاتصال يوم',
    callBackHint: 'فارغ: يوم العمل الموالي في غياب الرد، وإلا فلا.',
    report: 'محضر المكالمة',
    save: 'تسجيل المكالمة',
  },
  pilotage: {
    title: 'القيادة على 12 شهرا',
    dueWithin: (days: number) => `المستحق خلال ${days} يوما`,
    installments: (n: number) => `أقساط للتحصيل: ${n}`,
    renewalRate: 'نسبة التجديد',
    renewalDetail: (yes: number, no: number) => `مجددة: ${yes}، غير مجددة: ${no}`,
    collectedMonth: 'الأقساط المحصلة هذا الشهر',
    collectedYear: 'منذ 1 جانفي',
    lost: 'العقود المفقودة',
    since: (date: string) => `منذ ${date}`,
    byInsurer: 'المستحق خلال 90 يوما حسب شركة التأمين',
    count: 'الأقساط',
    amount: 'الباقي للتحصيل',
    lostRecent: 'آخر العقود المفقودة',
    noLost: 'لا توجد عقود مفقودة خلال الفترة.',
    reason: 'السبب',
  },
  settings: {
    notices: 'الإشعارات والوثائق',
    dueNoticeDays: 'الإشعار قبل الاستحقاق',
    dueNoticeHint:
      'تُرسل مراحل السيناريوهات المحتسبة من تاريخ الإشعار قبل كل قسط بهذا العدد من الأيام.',
    contractEndNoticeDays: 'التذكير قبل نهاية العقد',
    contractEndHint: 'رسالة إلى المؤمَّن له وملف تجديد في قائمة العمل (العقود دون تجديد ضمني).',
    noContractEndNotice: 'دون تذكير',
    attestationAfterPayment: 'إرسال شهادة الخلاص إلى المؤمَّن له بمجرد خلاص الفترة الجارية',
    attestationAfterPaymentShort: 'شهادة مرسلة بعد الخلاص',
    inherited: 'إعداد المكتب',
    inheritedHint: 'بالأيام؛ فارغ: إعداد المكتب.',
    title: 'الإعدادات',
    tenant: 'المكتب',
    insurers: 'شركات التأمين',
    productLines: 'خطوط المنتجات',
    agents: 'الوكلاء',
    users: 'المستخدمون',
    security: 'أمان الحساب',
    name: 'الاسم',
    timezone: 'المنطقة الزمنية',
    localeDefault: 'اللغة الافتراضية',
    sendWindow: 'نافذة الإرسال',
    sendDays: 'أيام الإرسال',
    dailyCap: 'الحد اليومي للرسائل',
    noCap: 'دون حد',
    logo: 'الشعار',
    uploadLogo: 'رفع (PNG أو JPEG، 200 كيلوبايت)',
    options: 'الخيارات',
    optionLabels: {
      llmClassification:
        'قراءة مساعدة للردود الحرة: يقترح نموذج لغوي نية الرد (نص مجهَّل الهوية، والقرار للمسيّر)',
      monthlyReportEmail: 'إرسال تقرير التحصيل الشهري إلى مديري النظام',
      allowInternationalPhones: 'قبول الأرقام الأجنبية عند الاستيراد',
      assignEscalationsToAgents: 'إسناد الإحالات والمكالمات إلى وكيل العقد بدل الفريق',
    },
    days: ['الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت', 'الأحد'],
    sending: 'وضع الإرسال',
    draftOn: 'وضع المسودة مفعّل: التذكيرات محاكاة فقط.',
    draftOff: 'الإرسال الفعلي مفعّل: تُرسل التذكيرات إلى المؤمَّن لهم.',
    activateSending: 'تفعيل الإرسال الفعلي',
    activateConfirm: 'اكتب ACTIVER لتأكيد الإرسال الفعلي للتذكيرات.',
    backToDraft: 'العودة إلى وضع المسودة',
    holidays: 'أيام العطل',
    holidayDate: 'التاريخ',
    holidayLabel: 'التسمية',
    addHoliday: 'إضافة يوم',
    holidayScopes: { national: 'وطني', tenant: 'المكتب' },
    holidayKinds: { fixed: 'ثابت', estimated: 'تقديري', confirmed: 'مؤكد' },
    code: 'الرمز',
    legalName: 'الاسم الاجتماعي',
    displayName: 'الاسم المعروض',
    senderName: 'مرسل الرسائل القصيرة (11 حرفًا)',
    legalMentions: 'البيانات القانونية',
    labelFr: 'التسمية (FR)',
    labelAr: 'التسمية (AR)',
    family: 'العائلة',
    defaultPeriodicity: 'الدورية الافتراضية',
    graceDays: 'مهلة السماح (أيام)',
    suspensionDays: 'التعليق بعد (أيام)',
    noSuspension: 'أبدًا',
    branch: 'الوكالة',
    phone: 'الهاتف',
    email: 'البريد الإلكتروني',
    linkedUser: 'المستخدم المرتبط',
    role: 'الدور',
    status: 'الحالة',
    userStatuses: {
      invited: 'مدعو',
      active: 'نشط',
      locked: 'مقفل',
      disabled: 'معطّل',
    },
    totp: 'TOTP',
    lastLogin: 'آخر تسجيل دخول',
    invite: 'دعوة مستخدم',
    invitationLink: 'رابط الدعوة لإرساله إلى الشخص المدعو',
    disable: 'تعطيل',
    enable: 'إعادة التفعيل',
    disableConfirm: 'تعطيل هذا الحساب؟ سيتم إغلاق جلساته.',
    totpTitle: 'المصادقة الثنائية (TOTP)',
    totpEnabled: 'مفعّلة',
    totpDisabled: 'معطّلة',
    totpStart: 'تفعيل المصادقة الثنائية',
    totpScan: 'أضف هذا الحساب إلى تطبيق المصادقة الخاص بك، ثم أدخل الرمز الظاهر.',
    totpSecret: 'المفتاح السري',
    totpCode: 'رمز من 6 أرقام',
    totpConfirm: 'تأكيد',
    totpDisable: 'تعطيل المصادقة الثنائية',
  },
  worklist: {
    title: 'قائمة المهام',
    mine: 'المسندة إليّ',
    team: 'الفريق (غير مسندة)',
    all: 'الكل',
    closed: 'مغلقة',
    sortAge: 'الأقدم أولًا',
    sortAmount: 'المبالغ الأكبر أولًا',
    kind: 'الطبيعة',
    kinds: {
      unpaid: 'غير مدفوع',
      optout: 'اعتراض',
      payment_check: 'دفع يجب التحقق منه',
      question: 'سؤال',
      overpayment: 'مبلغ زائد',
      refund: 'استرجاع',
      delivery: 'تعذّر الإرسال',
      renewal: 'تجديد',
      claim: 'حادث مصرح به',
    },
    statuses: { open: 'مفتوحة', in_progress: 'قيد المعالجة', closed: 'مغلقة' },
    openedAt: 'فُتحت في',
    remaining: 'المتبقي',
    assigned: 'مسندة إلى',
    nobody: 'الفريق',
    me: 'أنا',
    empty: 'لا توجد إحالات للمعالجة.',
    inbound: 'رسالة المؤمَّن له',
    suggestion: 'قراءة مقترحة (يجب التحقق منها)',
    intents: {
      paid_elsewhere: 'تم الدفع مسبقًا',
      stop: 'عدم تلقي الرسائل مستقبلًا',
      later: 'طلب مهلة',
      question: 'سؤال',
      other: 'أخرى',
    },
    detail: 'التفاصيل',
    notes: 'سجل المعالجة',
    messages: 'آخر الإرسالات',
    take: 'التكفل',
    note: 'إضافة ملاحظة',
    noteLabel: 'ملاحظة',
    call: 'تسجيل مكالمة',
    markPaid: 'وضع علامة مدفوع',
    grantDelay: 'منح مهلة',
    days: 'أيام',
    cancelContract: 'فسخ العقد',
    cancelConfirm: 'فسخ هذا العقد؟ سيتم إلغاء الأقساط القادمة.',
    close: 'إغلاق',
    resolution: 'الحل',
    reassign: 'إعادة الإسناد',
    actions: {
      take: 'التكفل',
      note: 'ملاحظة',
      call: 'مكالمة',
      mark_paid: 'مدفوع',
      grant_delay: 'مهلة ممنوحة',
      cancel_contract: 'فسخ',
      close: 'إغلاق',
      assign: 'إعادة إسناد',
    } as Record<string, string>,
    open: 'فتح',
  },
  payments: {
    record: 'تسجيل دفعة',
    amount: 'المبلغ (د.ت)',
    method: 'طريقة الدفع',
    paidAt: 'تاريخ الدفع',
    reference: 'المرجع',
    issueReceipt: 'إرسال وصل Beta Assur إلى المؤمَّن له',
    recorded: 'تم تسجيل الدفعة.',
    overpaid: 'تم الإبلاغ عن المبلغ الزائد في قائمة المهام',
    sendNow: 'إرسال المرحلة الحالية الآن',
    sendNowConfirm: 'إرسال المرحلة الحالية من التذكير فورًا (خارج البرمجة)؟',
    sent: 'تم طلب الإرسال.',
    payLink: 'رابط صفحة المؤمَّن له',
    showPayLink: 'عرض رابط الدفع',
  },
  bulk: {
    selected: {
      zero: 'لا شيء محدد',
      one: 'قسط واحد محدد',
      two: 'قسطان محددان',
      few: '{n} أقساط محددة',
      many: '{n} قسطا محددا',
      other: '{n} قسط محدد',
    },
    selectAll: 'تحديد الكل',
    select: 'تحديد',
    action: 'إجراء جماعي',
    actions: {
      start: 'بدء التذكير',
      pause: 'إيقاف مؤقت',
      resume: 'استئناف',
      stop: 'إيقاف التذكير',
      change_scenario: 'تغيير السيناريو',
      mark_paid: 'وضع علامة مدفوع',
    },
    scenario: 'السيناريو',
    preview: 'عرض الملخص',
    recap: 'الملخص',
    applicable: {
      zero: 'لا قسط معني',
      one: 'قسط واحد معني',
      two: 'قسطان معنيان',
      few: '{n} أقساط معنية',
      many: '{n} قسطا معنيا',
      other: '{n} قسط معني',
    },
    skipped: {
      one: 'واحد تم تجاهله',
      two: 'اثنان تم تجاهلهما',
      few: '{n} تم تجاهلها',
      many: '{n} تم تجاهلها',
      other: '{n} تم تجاهلها',
    },
    apply: 'تطبيق',
    applied: {
      zero: 'لم تتم معالجة أي قسط',
      one: 'تمت معالجة قسط واحد',
      two: 'تمت معالجة قسطين',
      few: 'تمت معالجة {n} أقساط',
      many: 'تمت معالجة {n} قسطا',
      other: 'تمت معالجة {n} قسط',
    },
  },
  rights: {
    title: 'الاعتراض والحقوق',
    optOutChannels: 'القنوات التي رفضها المؤمَّن له',
    saveOptOut: 'تسجيل الاعتراض',
    verifyPhone: 'التحقق من الرقم',
    sendCode: 'إرسال رمز عبر SMS',
    codeSent: 'تم إرسال الرمز. أدخل الرمز الذي أبلغك به المؤمَّن له.',
    code: 'الرمز الذي تلقاه المؤمَّن له',
    confirmCode: 'تأكيد',
    verified: 'تم التحقق من الرقم',
    export: 'تصدير البيانات (JSON)',
    anonymize: 'إخفاء هوية المؤمَّن له',
    anonymizeConfirm:
      'اكتب ANONYMISER: سيتم حذف الهوية وبيانات الاتصال نهائيًا، مع الاحتفاظ بالسجل المالي.',
    proof: 'إثبات الإرسال (PDF)',
  },
  integrations: {
    title: 'المراسلة والدفع',
    connect: 'المراسلة (SMS، واتساب، البريد الإلكتروني)',
    kashy: 'Kashy (الدفع عبر الإنترنت)',
    configured: 'مفعّل',
    missing: 'قيد التفعيل من Beta Suite',
    account: 'الحساب',
    suspended: 'الإرسال معلَّق لأسباب أمنية',
    suspendedHint:
      'إخفاقات إرسال حديثة كثيرة. تحقق من الأرقام والنماذج ثم أعد تفعيل الإرسال الفعلي.',
  },
  templateReview: {
    submit: 'الإرسال لموافقة واتساب',
    sync: 'تحديث الحالة',
    submitted: 'تم إرسال النموذج للمصادقة.',
    reviewNote: 'سبب الرفض',
  },
  mfa: {
    required: 'فعّل المصادقة الثنائية للوصول إلى البوابة (إلزامية لمديري النظام).',
  },
  onboarding: {
    title: 'انطلاق المكتب',
    sandbox: 'حساب تجريبي: لا رسائل ولا دفعات فعلية.',
    done: 'تم',
    todo: 'للإنجاز',
    steps: {
      insurer: 'إنشاء شركة تأمين واحدة على الأقل',
      products: 'إنشاء خطوط المنتجات',
      users: 'دعوة الفريق',
      portfolio: 'استيراد المحفظة',
      scenario: 'نشر سيناريو',
      templates: 'الحصول على المصادقة على نماذج WhatsApp',
      messaging: 'تفعيل المراسلة من Beta Suite',
      live: 'الخروج من وضع المسودة',
    },
  },
  connectors: {
    tab: 'موصل نظام المعلومات',
    intro:
      'يقرأ Beta Assur نظام معلوماتكم بصفة دورية وفي وضع القراءة فقط: لا تتم كتابة أي معطيات لديكم. تخضع كل قراءة لنفس عمليات التثبت المعتمدة في توريد الملفات.',
    url: 'عنوان المصدر',
    urlHint: 'واجهة JSON أو ملف CSV منشور، عبر HTTPS.',
    format: 'الصيغة',
    formats: { json: 'واجهة JSON', csv: 'ملف CSV' },
    interval: 'وتيرة القراءة',
    intervals: {
      15: 'كل 15 دقيقة',
      60: 'كل ساعة',
      360: 'كل 6 ساعات',
      1440: 'مرة في اليوم',
    },
    auth: 'النفاذ',
    auths: {
      none: 'دون مصادقة',
      bearer: 'رمز (Bearer)',
      basic: 'المعرف وكلمة المرور',
      header: 'مفتاح في ترويسة',
    },
    headerName: 'اسم الترويسة',
    secret: 'الرمز أو المفتاح',
    secretBasic: 'المعرف:كلمة المرور',
    secretHint: 'يحفظ مشفرا ولا يعرض مجددا.',
    secretKept: 'اتركه فارغا للإبقاء على النفاذ المسجل.',
    itemsPath: 'مسار السجلات',
    itemsPathHint: 'فارغ إذا كانت الإجابة جدولا مباشرة.',
    sinceParam: 'معامل «معدل منذ»',
    sinceParamHint: 'لقراءة التغييرات فقط منذ آخر قراءة ناجحة.',
    create: 'تسجيل المصدر',
    save: 'حفظ',
    edit: 'تعديل',
    remove: 'حذف الموصل',
    removeMessage: 'حذف هذا الموصل؟ تحفظ المعطيات التي تم توريدها.',
    activate: 'القراءة المبرمجة مفعلة',
    enabled: 'مفعل',
    disabled: 'غير مفعل',
    test: 'قراءة تجريبية',
    runNow: 'القراءة الآن',
    queued: 'تمت برمجة القراءة: تظهر النتيجة في السجل.',
    testResult: (rows: number, status: number) =>
      `قراءة تجريبية (HTTP ${status}): عدد السجلات ${rows}، لم يتم توريد أي شيء.`,
    saveMapping: 'حفظ المطابقة',
    mappingSaved: 'تم حفظ المطابقة.',
    missing: 'المطابقة غير مكتملة: قوموا بقراءة تجريبية واربطوا الحقول الإجبارية.',
    lastRun: 'آخر قراءة',
    never: 'أبدا',
    journal: 'سجل القراءات',
    noRuns: 'لا توجد قراءات بعد.',
    runAt: 'التاريخ',
    trigger: 'المصدر',
    triggers: { schedule: 'مبرمجة', manual: 'يدوية' },
    status: 'النتيجة',
    statuses: { ok: 'تم التوريد', empty: 'لا جديد', error: 'خطأ' },
    rows: 'السجلات',
    detail: 'التفاصيل',
    batch: 'عرض التوريد',
  },
  developers: {
    title: 'المطورون',
    keys: 'مفاتيح API',
    keyLabel: 'التسمية',
    scopes: 'الصلاحيات',
    scopeLabels: {
      read: 'قراءة',
      'contracts:write': 'العقود',
      'installments:write': 'الأقساط',
      'payments:write': 'الدفعات',
    },
    createKey: 'إنشاء المفتاح',
    newKey: 'مفتاح جديد: انسخه الآن.',
    newSecret: 'سر التوقيع: انسخه الآن.',
    shownOnce: 'لن يُعرض مرة أخرى. لا تُحفظ إلا بصمته.',
    prefix: 'البادئة',
    lastUsed: 'آخر استدعاء',
    never: 'أبدًا',
    revoked: 'ملغى',
    revoke: 'إلغاء',
    revokeMessage: 'سيتم رفض الاستدعاءات بهذا المفتاح فورًا.',
    example: 'مثال على الاستدعاء',
    docs: 'توثيق API العمومية:',
    requests: 'سجل الاستدعاءات',
    webhooks: 'Webhooks الصادرة',
    url: 'عنوان الاستقبال HTTPS',
    events: 'الأحداث',
    addWebhook: 'إضافة Webhook',
    active: 'نشط',
    deleteWebhook: 'لن يُرسل أي حدث إلى هذا العنوان بعد الآن.',
    deliveries: 'عمليات التسليم',
    deliveryStatuses: {
      pending: 'في الانتظار',
      delivered: 'تم التسليم',
      failed: 'محاولة جديدة مبرمجة',
      undelivered: 'لم يُسلَّم',
    },
    attempts: {
      zero: 'لا محاولة',
      one: 'محاولة واحدة',
      two: 'محاولتان',
      few: '{n} محاولات',
      many: '{n} محاولة',
      other: '{n} محاولة',
    },
    replay: 'إعادة الإرسال',
  },
  reports: {
    title: 'التقارير',
    kinds: {
      recovery: 'التحصيل',
      funnel: 'مسار التحويل',
      scenarios: 'السيناريوهات',
      channels: 'القنوات',
      quality: 'جودة البيانات',
      worklist: 'قائمة المهام',
      consumption: 'الاستهلاك',
      preferredChannels: 'القناة المفضلة',
    },
    summary: 'الخلاصة',
    previous: 'الفترة السابقة',
    insurer: 'شركة التأمين',
    periodLabel: 'الفترة:',
    exportCsv: 'تصدير بصيغة CSV',
    exportXlsx: 'تصدير بصيغة Excel',
    exports: 'تصدير القوائم',
    exportKinds: {
      installments: 'الأقساط',
      payments: 'الدفعات',
      messages: 'الرسائل',
      policyholders: 'المؤمَّن لهم',
    },
    monthly: 'تقارير التحصيل الشهرية',
    noMonthly: 'سيُودع أول تقرير شهري في اليوم الأول من الشهر القادم.',
    download: 'تنزيل',
  },
};
